import { App } from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AuthService from "@/core/services/Authservice";
import { AxiosResponse, AxiosRequestConfig } from "axios";
import { config } from "@/core/config";
import router from "@/router";
const auth = new AuthService();
var refreshingTokens = false;
/**
  * 暫且不用 get qurey put post delete 等等
*/

/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
  /**
   * @description property to share vue instance
   */
  public static vueInstance: App;

  /**
   * @description initialize vue axios
   */
  public static async init(app: App<Element>) {
    ApiService.vueInstance = app;
    ApiService.vueInstance.use(VueAxios, axios);
    ApiService.vueInstance.axios.defaults.baseURL = config.apiEndPoints.jma;
    ApiService.initRequestInterceptor();
    ApiService.initResponseInterceptor();
  }

  private static initRequestInterceptor = () => {
    ApiService.vueInstance.axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        //const token = localStorage.getItem('token');
       // const auth = token ? `Bearer ${token}` : '';
        //config.headers.common['Authorization'] = 'Bearer';
        //axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
        return config;
      },
      function (error) {
        // Do something with request error
        console.error("RequestInterceptor: ", error);
        return Promise.reject(error);
      }
    );
  };

  private static initResponseInterceptor = () => {
    ApiService.vueInstance.axios.interceptors.response.use(
      function (response) {
        // Do something with response data
        return response;
      },
      async function (error) {
        console.info(error, {
          baseUrl: error.response.config.baseURL,
          url: error.response.config.url
        })
        if (error.response) {
          switch (error.response.status) {
            case 404:
              console.log("你要找的頁面不存在")
              router.push('/404')
              // go to 404 page
              break
            case 500:
              console.log("程式發生問題")
              router.push('/500')
              // go to 500 page
              break
            //case 401:
            //ApiService.setHeader();
            //var token = await auth.getAccessToken();
            //const token = localStorage.getItem('token');
            //error.config.headers['Authorization'] = `Bearer ${token}`;

            //return await axios.request(error.config);

            default:
              console.log(error.message)
              console.log("error.config.headers", error.config.headers)
          }
        }
        if (!window.navigator.onLine) {
          alert("網路出了點問題，請重新連線後重整網頁");
          return;
        }
        return Promise.reject(error);
      }
    );
  }
  /**
   * @description set the default HTTP request headers
   */
  public static async setHeader(): Promise<void> {
    var token = await auth.getAccessToken();
    ApiService.vueInstance.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  /**
  * 暫且不用 get qurey put post delete 等等
  */

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static query(
    resource: string,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(resource, params).catch((error) => {
      throw new Error(`[KT] ApiService ${error}`);
    });
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param slug: string
   * @returns Promise<AxiosResponse>
   */
  public static get(
    resource: string,
    slug = "" as string
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios
      .get(`${resource}/${slug}`)
      .catch((error) => {
        throw new Error(`[KT] ApiService ${error}`);
      });
  }

  /**
   * @description set the POST HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static post(
    resource: string,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.post(`${resource}`, params);
  }

  /**
   * @description send the UPDATE HTTP request
   * @param resource: string
   * @param slug: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static update(
    resource: string,
    slug: string,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params);
  }

  /**
   * @description Send the PUT HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static put(
    resource: string,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}`, params);
  }

  /**
   * @description Send the DELETE HTTP request
   * @param resource: string
   * @returns Promise<AxiosResponse>
   */
  public static delete(resource: string): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.delete(resource).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }

}

export default ApiService;
